export default __webpack_public_path__ + "static/media/corporate4.58edb304.jpg";